import { useEffect, type ReactNode } from "react";

export function StatusPill({ status }: { status: string }) {
  const cls =
    status === "active"
      ? "pill pill-active"
      : status === "invited"
      ? "pill pill-invited"
      : status === "revoked"
      ? "pill pill-revoked"
      : "pill";
  const label =
    status === "active"
      ? "Active"
      : status === "invited"
      ? "Invited"
      : status === "revoked"
      ? "Revoked"
      : status;
  return (
    <span className={cls}>
      <span className="dot" />
      {label}
    </span>
  );
}

export function Toggle({
  value,
  onChange,
  partial = false,
}: {
  value: boolean;
  onChange?: (v: boolean) => void;
  partial?: boolean;
}) {
  const cls = "tg" + (value ? " on" : "") + (partial && !value ? " partial" : "");
  return (
    <div
      className={cls}
      role="switch"
      aria-checked={value}
      onClick={() => {
        if (onChange) onChange(!value);
      }}
    />
  );
}

export function Checkbox({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange?: (v: boolean) => void;
  children?: ReactNode;
}) {
  return (
    <label
      className={"checkbox" + (checked ? " on" : "")}
      onClick={(e) => {
        e.preventDefault();
        if (onChange) onChange(!checked);
      }}
    >
      <span className="box" />
      <span>{children}</span>
    </label>
  );
}

export function Modal({
  onClose,
  children,
  width,
}: {
  onClose: () => void;
  children: ReactNode;
  width?: number | string;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="scrim" onClick={onClose}>
      <div
        className="modal"
        style={width ? { width } : undefined}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export function Avatar({
  name,
  size = 28,
  brand = false,
}: {
  name: string;
  size?: number;
  brand?: boolean;
}) {
  const initials = (name || "?")
    .split(" ")
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase();
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: brand ? "var(--brand)" : "var(--ink)",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: Math.round(size * 0.38),
        fontWeight: 600,
        letterSpacing: 0.4,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}
